var App = App || {};

App.UpdateLocation = (function ($) {
    'use strict';

    function Init() {

        $("#UpdateLocationForm").submit(function (e) {
            e.preventDefault();

            $.post("/api/ContactLocation/UpdateLocation",
                {
                    Zip: $("#UpdateLocationID").val()
                },
                function (data, status) {
                    window.location.reload();
                });
        });

        setTimeout(function () {
            if ($("#locationFormModal").attr("data-gs-zipspeedbump") != "False") {
                console.log($("#locationFormModal").attr("data-gs-zipspeedbump"));

                $('#locationFormModal').modal('show');
            }
        }, 200);
     
    }

    return {
        Init: Init
    };

})(jQuery);